document.addEventListener('DOMContentLoaded', function () {
  const switcher = document.querySelector('.custom-weglot-switcher');
  if (!switcher) return;

  const active = switcher.querySelector('.active-language');

  function openSwitcher() {
    switcher.classList.add('open');
    switcher.classList.remove('closed');
    switcher.setAttribute('aria-expanded', 'true');
  }

  function closeSwitcher() {
    switcher.classList.remove('open');
    switcher.classList.add('closed');
    switcher.setAttribute('aria-expanded', 'false');
  }

  active.addEventListener('click', function (e) {
    e.preventDefault();
    if (switcher.classList.contains('open')) {
      closeSwitcher();
    } else {
      openSwitcher();
    }
  });

  switcher.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (switcher.classList.contains('open')) {
        closeSwitcher();
      } else {
        openSwitcher();
      }
    }

    if (e.key === 'Escape') {
      closeSwitcher();
    }
  });

  document.addEventListener('click', function (e) {
    if (!switcher.contains(e.target)) {
      closeSwitcher();
    }
  });
});